var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row justify-around"},[_c('AtomSpinner',{staticClass:"mt-5 mb-5",attrs:{"animation-duration":1000,"size":60,"color":'#7367F0'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }